export class EventActivityUtils {

    public static getDaysInMonth(date = null) {
        let dt = new Date(date) || new Date();
        let month = dt.getMonth() + 1;
        let year = dt.getFullYear();
        let daysInMonth = new Date(year, month, 0).getDate();
        return daysInMonth;
    }

    public static getLastMonday(date) {
        let dt = new Date(date);
        let day = dt.getDay();
        let diff = dt.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
        return new Date(dt.setDate(diff));
    }

    public static getUpcomingSunday(date) {
        let dt = new Date(date);
        let today = dt.getDate();
        let dayOfTheWeek = dt.getDay();
        let diff = today + (dayOfTheWeek == 0 ? 0 : 7 - dayOfTheWeek);
        let newDate = dt.setDate(diff);
        return new Date(newDate);
    }

    public static getDDMM(date) {
        let dt = new Date(date);
        let day = dt.getDate();
        let month = dt.getMonth() + 1;
        let formatted = (day > 9) ? day + "" : "0" + day;
        formatted = formatted + '.' + ((month > 9) ? month + "" : "0" + month);
        return formatted;
    }

}


// WEBPACK FOOTER //
// /src/pages/event/event-activity-tabs/event-forest/event-activity-utils.ts